import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import Footer from "../../footer";
import Header from "../../Header/index";
import "./style.css";
import Video from "../../../assets/img/welcome.mp4";
import { API_BASE_URL } from "../../../config/config";

const Jobshow = () => {
  const { id } = useParams();
  const [vacancy, setVacancy] = useState(null);
  const [, setLatestVacancies] = useState([]);
  const { t, i18n } = useTranslation();

  const languageMap = { tj: 1, ru: 2, en: 3 };
  const getLanguageCode = (lang) => languageMap[lang] || 2;

  const fetchVacancy = (vacancyId, langCode) => {
    axios
      .get(`${API_BASE_URL}/api/events/${vacancyId}?lang=${langCode}`, {
        headers: {
          accept: "text/plain",
          "api-version": "1.0",
        },
      })
      .then((response) => {
        setVacancy(response.data);
      })
      .catch((error) => {
        console.error("Error fetching vacancy:", error);
      });
  };

  const fetchLatestVacancies = (langCode) => {
    axios
      .get(
        `${API_BASE_URL}/api/events/events-vacancies?lang=${langCode}&page=1`,
        {
          headers: {
            accept: "text/plain",
            "api-version": "1.0",
          },
        },
      )
      .then((response) => {
        setLatestVacancies(response.data.enttities?.slice(0, 6) || []);
      })
      .catch((error) => {
        console.error("Error fetching latest vacancies:", error);
      });
  };

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);
    fetchVacancy(id, langCode);
    fetchLatestVacancies(langCode);
  }, [id, i18n.language]);

  if (!vacancy) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">{t("Loading...")}</span>
          </div>
          <p className="text-muted">{t("Loading...")}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="position-relative text-white" style={{ height: "200px" }}>
        <video
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src={Video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 5000,
          }}
        >
          <Header />
        </div>
      </div>
      <main>
        <div className="container mainjobshowblock px-4 px-md-5">
          <div className="row justify-content-center">
            <div className="col-12 text-start">
              <h2 className="fw-bold display-5 text-dark ">{t("JobShow")}</h2>
            </div>
          </div>
          <div className="row justify-content-center py-5">
            <div className="col-12">
              <div className="card border-0 shadow-lg h-100 d-flex flex-column">
                <div className="noHoverClass card-body p-4 p-md-5 flex-grow-1">
                  <div className="noHoverClass row align-items-start">
                    {vacancy.image && (
                      <div className="noHoverClass col-12 col-md-4 col-lg-3 mb-4 mb-md-0">
                        <div className="noHoverClass text-center">
                          <img
                            src={vacancy.image}
                            alt="Job Position"
                            className="img-fluid rounded-3 shadow"
                            style={{
                              width: "100%",
                              maxWidth: "200px",
                              height: "auto",
                              maxHeight: "250px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      </div>
                    )}
                    <div
                      className={
                        vacancy.image ? "col-12 col-md-8 col-lg-9" : "col-12"
                      }
                    >
                      <div className="noHoverClass job-content">
                        {vacancy.name && (
                          <h1 className="display-6 fw-bold text-dark mb-4 border-bottom pb-3">
                            {vacancy.name}
                          </h1>
                        )}
                        <div className="job-description">
                          <p
                            className="lead text-muted mb-4"
                            style={{ lineHeight: "1.8" }}
                            dangerouslySetInnerHTML={{
                              __html: vacancy.longDesc,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-footer bg-transparent border-0 mt-auto">
                  <div className="d-grid">
                    <Link
                      to={`/job`}
                      className="btn btn-lg py-3 text-white fw-bold border-0 rounded-3 shadow"
                      style={{
                        background: "#1D5252",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 25px rgba(29, 82, 82, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)";
                      }}
                    >
                      <i className="fas fa-briefcase me-2"></i>
                      {t("View All")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Jobshow;
